import { render, staticRenderFns } from "./SmartTicket.vue?vue&type=template&id=2063a516&scoped=true&"
import script from "./SmartTicket.vue?vue&type=script&lang=js&"
export * from "./SmartTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063a516",
  null
  
)

export default component.exports